import { Image, Package } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";

export const IconBadge = ({ app }) => {
  const { t } = useI18n();
  const fromApk = app.icon_source === "apk";
  const Icon = fromApk ? Package : Image;
  return (
    <span className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[0.65rem] font-semibold ${fromApk ? "border-emerald-500/50 text-emerald-200" : "border-amber-400/50 text-amber-200"}`} data-testid={`icon-badge-${app.id}`}>
      <Icon className="h-3 w-3" /> {t(fromApk ? "icon.fromApk" : "icon.custom")}
    </span>
  );
};
